import React from 'react';
import './ChatInitializationLoaderComponent.scss';

interface ChatInitializationLoaderComponentProps {
    isVisible: boolean;
    message?: string;
}

const ChatInitializationLoaderComponent: React.FC<ChatInitializationLoaderComponentProps> = ({ 
    isVisible, 
    message = "Initializing chat..." 
}) => {
    if (!isVisible) return null;

    return (
        <div className="chat-initialization-loader">
            <div className="loader-content">
                <div className="spinner">
                    <div className="spinner-dot"></div>
                    <div className="spinner-dot"></div>
                    <div className="spinner-dot"></div>
                </div>
                <span className="loader-text">{message}</span>
            </div>
        </div>
    );
};

export default ChatInitializationLoaderComponent;
